<template>
  <div class="view-container">
    <a-row style="margin-bottom: 0.623vw;">
      <a-button type="primary" @click="openModal">添加分类</a-button>
    </a-row>
    <a-row>
      <a-table
        :columns="columns"
        :rowKey="record => record.id"
        :dataSource="tableData"
        :pagination="true"
        :bordered="true"
        :rowClassName="tableRowClass"
      >
        <template slot="operation" slot-scope="text, record">
          <a
            @click="() => onEdit(record)"
            href="javascript:;"
            style="margin-right: 15px;"
          >
            <a-icon type="edit" theme="twoTone" />编辑
          </a>
          <a-popconfirm
            v-if="tableData.length"
            title="确定删除吗 ?"
            @confirm="() => onDelete(record.id)"
          >
            <a href="javascript:;"> <a-icon type="delete" />删除 </a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-row>
    <a-modal
      :title="title"
      v-model="isVisible"
      @ok="handleOk"
      @cancel="handleCancel"
      :width="600"
      :confirm-loading="confirmLoading"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        layout="horizontal"
      >
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="名称" prop="name">
              <a-input v-model="form.name" placeholder="请输入名称" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="描述" prop="description">
              <a-textarea v-model="form.description" placeholder="请输入描述" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  getCategories,
  addCategory,
  removeCategoryInBatch,
  updateCategory,
  getCategoryById
} from '@/api/course/course'

export default {
  data() {
    return {
      columns: [],
      tableData: [],
      isVisible: false,
      title: '添加分类',
      editId: null,

      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      confirmLoading: false,
      form: {
        name: undefined,
        description: undefined
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          }
        ],
        description: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.columns = [
      {
        title: '分类名称',
        dataIndex: 'name',
        width: '20%',
        sorter: (a, b) => a.name >= b.name
      },
      {
        title: '描述',
        dataIndex: 'description'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.fetchData()
  },
  methods: {
    fetchData() {
      getCategories().then(res => {
        if (res.code === 200) {
          this.tableData = res.result
        }
      })
    },
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        return 'row-class-odd'
      }
    },
    onDelete(key) {
      const ids = [key].join(',')
      removeCategoryInBatch({ ids }).then(res => {
        if (res.code === 200) {
          this.$notification['success']({
            message: '成功',
            description: '删除成功',
            duration: 3
          })
          this.fetchData()
        }
      })
    },
    onEdit(record) {
      this.isVisible = true
      this.title = '修改类型'
      this.editId = record.id
      getCategoryById(this.editId).then(res => {
        if (res.code === 200) {
          let result = res.result
          Object.keys(this.form).forEach(key => {
            this.form[key] = result[key]
          })
        }
      })
    },
    openModal() {
      this.isVisible = true
      this.title = '添加类型'
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    handleCancel() {
      this.isVisible = false
      this.resetForm()
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const { form } = this
          if (this.title === '添加类型') {
            addCategory(form).then(res => {
              if (res.code === 200) {
                this.$notification['success']({
                  message: '成功',
                  description: '添加成功'
                })
                this.isVisible = false
                this.resetForm()
                this.fetchData()
              }
            })
          } else if (this.title === '修改类型') {
            const { editId } = this
            updateCategory(editId, form).then(res => {
              if (res.code === 200) {
                this.$notification['success']({
                  message: '成功',
                  description: '修改成功'
                })
                this.isVisible = false
                this.resetForm()
                this.fetchData()
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style></style>
